import React, { FC } from 'react'
import styled from 'styled-components'
import { KVAnnotation } from 'types'

const SeverityCircleShape = styled.div`
  height: 20px;
  width: 20px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  flex-direction: column;
  position: relative;
  flex-shrink: 0;
`

const DimOverlay = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: rgba(50, 50, 50, 0.3);
`

const SeverityText = styled.div`
  text-align: center;
  font-size: 14px;
`

export const SeverityCircle: FC<{
  annotation: KVAnnotation
}> = ({ annotation }) => {
  const bgColor =
    annotation.severity === '1'
      ? 'rgb(209, 209, 205)'
      : annotation.severity === '2'
        ? 'rgb(223, 214, 98)'
        : annotation.severity === '3'
          ? 'rgb(223, 174, 2)'
          : annotation.severity === '4'
            ? 'rgb(219, 109, 0)'
            : annotation.severity === '5'
              ? 'rgb(179, 0, 0)'
              : 'rgb(80, 80, 80)'

  const textColor = annotation.severity === '5' ? 'white' : 'black'

  return (
    <SeverityCircleShape style={{ backgroundColor: bgColor }}>
      {!annotation.visible && <DimOverlay />}
      <SeverityText style={{ color: textColor }}>
        {annotation.severity}
      </SeverityText>
    </SeverityCircleShape>
  )
}
